import * as Yup from 'yup';

import { SupportTopic } from '@yoweb/types/enums';
import hasFullWidthChars from '@yoweb/utils/intl/hasFullWidthChars';
import type { SelectOptions } from '@yoweb/ui/components/form/SelectDropdown';
import type { YoFormFactory } from '@yoweb/ui/hooks/forms';
import type { TFunction } from '@yoweb/next-i18next';

const form: YoFormFactory<'common'> = (t, { localeHasFullWidthChars }) => ({
  topic: {
    defaultValue: '',
    validation: Yup.string().trim().required(t('validation.required')),
  },
  givenName: {
    defaultValue: '',
    validation: Yup.string().trim().required(t('validation.required')),
  },
  familyName: {
    defaultValue: '',
    validation: Yup.string().trim().required(t('validation.required')),
  },
  email: {
    defaultValue: '',
    validation: Yup.string()
      .trim()
      .test({
        message: t('validation.enter-half-width-characters'),
        test: (value) => (value && localeHasFullWidthChars ? !hasFullWidthChars(value) : true),
      })
      .email(t('validation.enter-valid-address'))
      .required(t('validation.required')),
  },
  description: {
    defaultValue: '',
    validation: Yup.string().trim().required(t('validation.required')),
  },
});

export const getTopicsOptions = (t: TFunction): SelectOptions[] =>
  [
    SupportTopic.EXISTING_MEMBERSHIP,
    SupportTopic.YO_APP,
    SupportTopic.BILLING_PURCHASES_ACCOUNT,
    SupportTopic.PARTNER_AFFILIATE,
    SupportTopic.PRESS,
    SupportTopic.URGENT,
  ].map((option) => ({
    value: option,
    label: t(`topic.topics.${option}`, { ns: 'help-form' }),
  }));

export default form;
